export default __webpack_public_path__ + "static/media/location_description.7ad55820.png";